import { useTypedSelector } from 'src/State/RootReducer'
import { SHOP_E3DC_ID, SHOP_INTERNAL_CH_ID, SHOP_INTERNAL_NL_ID, SHOP_INTERNAL_FLOW_ID } from '../consts'
import { SHOP_CHANNEL_DEFAULT_RULES, SHOP_CHANNEL_RULES_TYPE, ShopChannelDefaultRules, ShopChannelType } from '../utils/shop-channel-rules'

/*
 * Custom hook to get the current shop channel rules
 */
export const useShopChannelRules = (): ShopChannelDefaultRules => {
  const shopChannelType = useShopChannelType()

  const rules: ShopChannelDefaultRules = shopChannelType ? SHOP_CHANNEL_RULES_TYPE[shopChannelType] : SHOP_CHANNEL_DEFAULT_RULES

  return rules
}

/*
 *  This function returns the shop type for the user
 */
export const useShopChannelType = (): ShopChannelType | null => {
  const shopId = useTypedSelector(state => state.shop.shopChannelId)

  if (!shopId) return null
  if (shopId === SHOP_E3DC_ID) return ShopChannelType.ShopE3dc
  if (shopId === SHOP_INTERNAL_CH_ID) return ShopChannelType.ShopInternalCh
  if (shopId === SHOP_INTERNAL_NL_ID) return ShopChannelType.ShopInternalNL
  if (shopId === SHOP_INTERNAL_FLOW_ID) return ShopChannelType.ShopInternalFlow

  return null
}
